import { Tooltip as RadixTooltip } from 'radix-ui';
import type { ReactNode } from 'react';
import { Shortcut } from './kbd';

export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <RadixTooltip.Provider delayDuration={450} skipDelayDuration={250}>
      {children}
    </RadixTooltip.Provider>
  );
}

export interface TooltipProps {
  content: ReactNode;
  /** Keyboard shortcut shown after the label, e.g. `['⌘', 'K']`. */
  shortcut?: readonly string[];
  side?: 'top' | 'right' | 'bottom' | 'left';
  children: ReactNode;
}

export function Tooltip({ content, shortcut, side = 'bottom', children }: TooltipProps) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={6}
          collisionPadding={8}
          className="z-50 flex max-w-72 animate-fade-in items-center gap-2 rounded-md bg-bg-2 px-2 py-1 text-xs text-text-1 shadow-popover"
        >
          <span>{content}</span>
          {shortcut && <Shortcut keys={shortcut} />}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
